// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"0b461e58","107":"016dfe1d","252":"a9032a79","272":"154d2665","488":"24c8f1dd","592":"83a768df","676":"a2470172","706":"7ae84837","900":"274e510b","933":"b5ef7524"}[chunkId] + ".chunk.css";
};